import React from "react";

const MajorProjects = () => {
  const projects = [
    {
      id: 0,
      description:
        "Survey Investigation & preparation of DPR for R&B division Deogarh (05 no Road).",
      animation: "fade-up",
    },
    {
      id: 1,
      description:
        "Survey Investigation & preparation of DPR for R&B division paralakhemundi (MMPKG Road, SH-4) FWD & complete DPR.",
      animation: "fade-up",
    },
    {
      id: 2,
      description:
        "Quality Control for NH 326 (Malkangir Jeypore) & 326A (Paralakhemundi) for Superintending Engineer, NH circle (South), Berhampur.",
      animation: "fade-right",
    },
    {
      id: 3,
      description: "Sub-soil Exploration for NALCO, Damanjodi, Koraput.",
      animation: "fade-left",
    },
    {
      id: 4,
      description:
        "NDT both Rebound Hammer & UPV for Mahanadi HL Bridge Athamallik-Dhalpur of Angul / Boudh District (Client- Ranjit Buildcon).",
      animation: "zoom-in",
    },
    {
      id: 5,
      description:
        "Survey & Sub-soil Exploration for construction of EMRS various locations in Odisha (Client- HSCL, Bhubaneswar).",
      animation: "flip-up",
    },
    {
      id: 6,
      description:
        "Geo-Technical Investigation for Major Bridges (1RB & 90A) of Angul-Sukinda New B.G Rail link project of East Coast Railway (Client- RVNL, Bhubaneswar).",
      animation: "zoom-out",
    },
    {
      id: 7,
      description:
        "Survey & Preparation of Sketch Map of 162.78 Acres of Land under RHEP, Rengali (Client- OHPC, Rengali).",
      animation: "fade-up-right",
    },
    {
      id: 8,
      description:
        "Survey & Preparation of Sketch Map for various works under Jajpur district of Odisha (Client- NBCC, Bhubaneswar).",
      animation: "flip-left",
    },
    {
      id: 9,
      description:
        "NDT both Rebound Hammer & UPV on Sub structure & super-structure of Major bridges between Budhapank to Baghuapal & Rengali left branch Canal under Angul-Sukinda new B.G Rail link project (Client- RVNL, Bhubaneswar).",
      animation: "slide-up",
    },
    {
      id: 10,
      description:
        "Conducting Non-Destructive Testing (NDT) using both Rebound Hammer and Ultrasonic Pulse Velocity (UPV) methods on the sub-structures and super-structures of major and minor bridges along the route from Sagadapata to Tangiriapal, as part of the doubling project between Jaroli and Jakhapura (Client: RVNL, Bhubaneswar).",
      animation: "flip-up",
    },
    {
      id: 11,
      description:
        "Prepairation of DPR SVD, BVD 10 NO of vectonary from OCC LTD.",
      animation: "flip-up",
    },
  ];

  return (
    <React.Fragment>
      <div className="py-12 md:mx-16 mx-6">
        {/* <h1 className="text-3xl lg:text-5xl font-semibold text-center mb-4">Major Projects</h1>
                <p className="text-gray-600 text-base md:text-md lg:text-xl mx-auto text-center max-w-[70%]">
                    These projects often involve collaboration across multiple sectors, advanced technology, and strategic planning to meet client objectives. They highlight the company’s commitment to excellence, innovation, and successful project execution from start to finish.
                </p> */}
        <div className="md:max-w-[70%] mx-auto text-center">
          <h1 className="text-3xl lg:text-5xl font-semibold text-center mb-4">
            Major Projects
          </h1>
          <p className="text-gray-600 text-base md:text-md lg:text-xl ">
            These projects often involve collaboration across multiple sectors,
            advanced technology, and strategic planning to meet client
            objectives. They highlight the company’s commitment to excellence,
            innovation, and successful project execution from start to finish.
          </p>
        </div>
        {/* <div className="grid lg:grid-cols-2 grid-cols-1 mt-7 md:mt-14 gap-8">
                    {projects.map((project) => (
                        <div
                            key={project.id}
                            className="relative md:py-16 py-8 px-6 text-center border rounded-lg shadow-md"
                            data-aos={project.animation} // Apply different AOS animation
                        >
                            <div style={{ fontFamily: "Oregano, cursive" }} className="absolute -top-5 right-6 bg-blue-600 text-white rounded-full w-10 h-10 lg:w-14 lg:h-14 text-2xl lg:text-4xl flex items-center justify-center">
                                {project.id}
                            </div>
                            <p className='text-base md:text-md lg:text-md 2xl:text-xl'>{project.description}</p>
                        </div>
                        
                    ))}
                </div> */}

        {/* <div className="mt-7 md:mt-14">
          {projects.map((project) => (
            <ol
              key={project.id}
              className="py-2 px-6 text-start list-none flex items-center gap-2"
              data-aos={project.animation} // Apply different AOS animation
            >
              <li className="before:content-['*'] before:mr-2 before:font-bold text-xl"></li>
              <li className=" text-base md:text-md lg:text-md 2xl:text-xl">
                {project.description}
              </li>
            </ol>
          ))}
        </div> */}
        <div className="mt-7 md:mt-10">
          {projects.map((project) => (
            <ol
              key={project.id}
              className="py-2 px-6 text-start list-none "
              data-aos={project.animation} // Apply different AOS animation
            >
              <li className="before:content-['*'] before:mr-2 before:font-bold text-base md:text-sm lg:text-lg font-medium ">
                {project.description}
              </li>
            </ol>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default MajorProjects;
